import queryString from 'query-string';
import { DeliveryNoteRow, OrderDetail } from 'src/adminPanelV2/api/ordersV2';
import callApi, { CallApiResult, getCustomerId } from 'src/api';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';

export interface CustomerOrdersFilterParams {
    dateFrom?: string;
    dateTo?: string;
    search?: string;
    billingAddressKeys?: string[];
    deliveryAddressKeys?: string[];
    articleGroups?: number[];
}

export type CustomerOrdersQueryParams = PageableQueryParams & CustomerOrdersFilterParams;

export const fetchCustomerOrders = (params: CustomerOrdersQueryParams = {}): Promise<CallApiResult> => {
    // query-string v4 serializes arrays as repeated params (key=a&key=b), matching Spring's List<String> binding
    let query = queryString.stringify(params, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const customerId = getCustomerId() === 'current' ? '' : '/' + getCustomerId();
    const endpoint = `/api/customerOrders${customerId}${query}`;

    return callApi(endpoint);
};

export const fetchCustomerOrderAddressOptions = (): Promise<CallApiResult> => {
    const customerId = getCustomerId() === 'current' ? '' : '/' + getCustomerId();
    return callApi(`/api/customerOrders${customerId}/addressOptions`);
};

export interface CustomerOrderArticleGroupOption {
    key: number;
    labelKey: string;
    label: string;
}

/** R63: the article groups found in the customer's own orders, for the Produktgruppe filter. */
export const fetchCustomerOrderArticleGroupOptions = (): Promise<
    CallApiResult<{ articleGroups: CustomerOrderArticleGroupOption[] }>
> => {
    const customerId = getCustomerId() === 'current' ? '' : '/' + getCustomerId();
    return callApi(`/api/customerOrders${customerId}/articleGroupOptions`);
};

/** R45-9: the Bestelldetails popup data of one of the logged-in customer's own orders (404 for any other). */
export const fetchOwnOrderDetail = (publicId: string): Promise<CallApiResult<OrderDetail>> =>
    callApi(`/api/customerOrders/details/${encodeURIComponent(publicId)}`);

export const fetchOwnOrderDeliveryNotes = (publicId: string): Promise<CallApiResult<DeliveryNoteRow[]>> =>
    callApi(`/api/customerOrders/details/${encodeURIComponent(publicId)}/deliveryNotes`);

export const fetchCustomerAbos = (customerId: string = getCustomerId()): Promise<CallApiResult> => {
    return callApi(`/api/customer/${customerId}/subscriptions`);
};

export const deleteCustomerAbo = (id: string, customerId: string = getCustomerId()): Promise<CallApiResult> => {
    return callApi(`/api/customer/${customerId}/subscriptions/${id}`, { method: 'DELETE' });
};
